import { render, staticRenderFns } from "./FormsColleges.vue?vue&type=template&id=d367b506"
import script from "./FormsColleges.vue?vue&type=script&lang=js"
export * from "./FormsColleges.vue?vue&type=script&lang=js"
import style0 from "./FormsColleges.vue?vue&type=style&index=0&id=d367b506&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports